import React, { useEffect, useState } from 'react'
import StepLabel from '@material-ui/core/StepLabel'

const WithActive = (Component: any) => {
  const NewComponent = (props: any) => {
    const [isActive, setIsActive] = useState(false)
    const { children } = props
    const allChildren = React.Children.map(children, (child) => {
      const clone = React.cloneElement(child, { setIsActive })
      return clone
    })

    return (
      <Component
        className={`o-form-libranzas__steplabel ${isActive ? '--active' : ''}`}
        setActive={setIsActive}
        {...props}
      >
        {allChildren}
      </Component>
    )
  }
  return NewComponent
}

export default WithActive(StepLabel)
